import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";
import { contactMethodOptions } from "validations/patientSchemas";

function ContactInformationSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Contact Information
      </Typography>

      <Box className="grid grid-cols-3 gap-4">
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              fullWidth
              error={!!errors.email}
              helperText={errors.email?.message}
              {...field}
            />
          )}
        />

        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => (
            <TextField
              id="phone-number"
              label="Phone Number"
              variant="outlined"
              fullWidth
              error={!!errors.phoneNumber}
              helperText={errors.phoneNumber?.message}
              {...field}
            />
          )}
        />

        <Controller
          name="alternativePhone"
          control={control}
          render={({ field }) => (
            <TextField
              id="alternative-phone"
              label="Alternative Phone (optional)"
              variant="outlined"
              fullWidth
              error={!!errors.alternativePhone}
              helperText={errors.alternativePhone?.message}
              {...field}
            />
          )}
        />
      </Box>

      <Box className="mt-4">
        <Typography variant="body1" className="font-medium mb-2">
          Preferred Contact Method
        </Typography>

        <Controller
          name="preferredContactMethod"
          control={control}
          render={({ field }) => (
            <FormControl
              error={!!errors.preferredContactMethod}
              className="w-full"
            >
              <RadioGroup
                row
                aria-labelledby="preferred-contact-method"
                {...field}
                value={field.value || ""}
              >
                {contactMethodOptions.map((option) => (
                  <FormControlLabel
                    key={option}
                    value={option}
                    control={<Radio />}
                    label={option}
                  />
                ))}
              </RadioGroup>
              {errors.preferredContactMethod && (
                <FormHelperText>
                  {errors.preferredContactMethod.message}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />
      </Box>
    </Box>
  );
}

export default ContactInformationSection;
